import axios from 'axios';
import { ButtonGroup, ComboBox, DataGrid, Dialog, Form, FormField, GridColumn, Label, Layout, LayoutPanel, LinkButton, Panel, TextBox } from 'rc-easyui';
import React, { Component } from 'react';
import { uAPIlocal } from '../../lib/config';
import { Button, DatePicker, TimePicker, Checkbox, Select, Space, Flex, Radio } from 'antd';
import Loader from 'react-loader-spinner';
import {
    Row,
    Col,
} from "react-bootstrap";

class MasterKonsultasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            master_users: {
                total: 0,
                pageSize: 20,
                data: [],
                pagePosition: "bottom",
                pageOptions: {
                    layout: ['list', 'sep', 'first', 'prev', 'next', 'last', 'sep', 'refresh', 'sep', 'manual', 'info']
                },
                selection: null,
                loading: true,
            },
            formTambah: {
                field: {
                    username: "",
                    name: "",
                    email: "",
                    password: "",
                    level: "",
                    status_login: "",
                    Company_ID: "",
                    branch_code: "",
                    ID_DOKTER: "",
                },
                rules: {
                    username: ["required"],
                    name: ["required"],
                    email: ["required"],
                    password: ["required"],
                    level: ["required"],
                    // status_login: "",
                    // Company_ID: "",
                    branch_code: ["required"],
                    ID_DOKTER: "",
                }
            },
            formEdit: {
                field: {
                    username: "",
                    name: "",
                    email: "",
                    password: "",
                    level: "",
                    status_login: "",
                    Company_ID: "",
                    branch_code: "",
                    ID_DOKTER: "",
                },
                rules: {
                    // username: ["required"],
                    // name: ["required"],
                    // email: ["required"],
                    // password: ["required"],
                    // level: ["required"],
                    // status_login: "",
                    // Company_ID: "",
                    // branch_code: ["required"],
                    ID_DOKTER: "",
                }
            },
            loader: false,
            selectedLevel: [{ value: 1, label: "Administrasi" }],
            selectedStatusLogin: [{ value: "AKTIF", label: "AKTIF" }],
        }
        this.errorDialog = React.createRef();
        this.tambahConc = React.createRef();
        this.editConc = React.createRef();

        this.pageChange = this.pageChange.bind(this);
        this.selectionChange = this.selectionChange.bind(this);

        this.formTambah = React.createRef();
        this.handleChangeFormTambah = this.handleChangeFormTambah.bind(this);
        this.handleSubmitFormTambah = this.handleSubmitFormTambah.bind(this);

        this.formEdit = React.createRef();
        this.handleEditClick = this.handleEditClick.bind(this)
        this.handleChangeformEdit = this.handleChangeformEdit.bind(this);
        this.handleSubmitformEdit = this.handleSubmitformEdit.bind(this);

        this.removeDialog = React.createRef();
        this.removedData = this.removedData.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
        this.getBranch = this.getBranch.bind(this);
        this.getDokter = this.getDokter.bind(this);
        this.handleOnChangeLevel = this.handleOnChangeLevel.bind(this);
        this.handleOnChangeStatusLogin = this.handleOnChangeStatusLogin.bind(this);
    }

    async getData() {
        await axios.post(uAPIlocal + '/api/v1/users')
            .then(function (response) {
                return response.data.results;
            })
            .then(response => {
                // console.log(response)
                const datas = response.sort(function (a, b) {
                    return  a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                });

                console.log("ini datas", datas);

                this.setState({
                    master_users: {
                        ...this.state.master_users,
                        data: datas,
                        loading: false
                    }
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getBranch() {
        await axios.post(uAPIlocal + `/api/v1/branch`)
            .then(response =>
                // console.log("ini Branch",response),
                response.data.results.map(item => ({
                    value: `${item.branch_code}`,
                    text: `${item.branch_name}`,
                }))
            )
            .then(Branch => {
                this.setState({
                    Branch: Branch,
                    chooseBranch: Branch[0],
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async getDokter() {
        await axios.post(uAPIlocal + `/api/v1/dokter`)
            .then(response =>
                // console.log("ini Branch",response),
                response.data.results.map(item => ({
                    value: `${item.ID_DOKTER}`,
                    text: `${item.NAMA_DOKTER}`,
                }))
            )
            .then(Dokter => {
                let _dokter = [...Dokter, {value: '0',text: `Bukan Dokter`}];
                const myDokter = _dokter.sort(function (a, b) {
                    return a.value - b.value;
                });

                console.log("ini dokter", myDokter)

                this.setState({
                    Dokter: myDokter,
                    chooseDokter: myDokter[0],
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    changeSelectBranch = (e) => {
        this.setState({ chooseBranch: e })
    }

    changeSelectDokter = (e) => {
        this.setState({ chooseDokter: e })
    }

    pageChange(event) {
        // console.log(event)
        if (event.refresh) {
            // console.log(event)
            this.setState({
                master_users: {
                    ...this.state.master_users,
                    loading: true,
                    selection: null
                },
            })
            this.getData();
        }

    }
    async selectionChange(event) {
        // console.log(event)
        // next edit disini

        let indexDokter = this.state.Dokter.findIndex(function (item, i) {
            return item.value == event.ID_DOKTER
        });
        let indexBranch = this.state.Branch.findIndex(function (item, i) {
            return item.value == event.branch_code
        });
        await this.setState({
            master_users: {
                ...this.state.master_users,
                selection: event
            },
            chooseBranch: this.state.Branch[indexBranch],
            chooseDokter: this.state.Dokter[indexDokter],
        })
    }

    async handleChangeFormTambah(name, value) {
        let field = Object.assign({}, this.state.formTambah.field);
        field[name] = value;
        await this.setState({
            formTambah: {
                ...this.state.formTambah,
                field: field
            }
        }, () => console.log(this.state.formTambah.field))
    }

    async handleSubmitFormTambah() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const username = this.state.formTambah.field.username;
        const name = this.state.formTambah.field.name;
        const email = this.state.formTambah.field.email;
        const password = this.state.formTambah.field.password;
        // const level = this.state.formTambah.field.level;
        // const status_login = this.state.formTambah.field.status_login;
        const Company_ID = this.state.formTambah.field.Company_ID;
        // const branch_code = this.state.formTambah.field.branch_code;
        // const ID_DOKTER = this.state.formTambah.field.ID_DOKTER;

        formData.append('username', username);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('password', password);
        formData.append('level', this.state.selectedLevel[0].value);
        formData.append('status_login', this.state.selectedStatusLogin[0].value);
        formData.append('Company_ID', Company_ID);
        formData.append('branch_code', this.state.chooseBranch);
        formData.append('ID_DOKTER', this.state.chooseDokter);


        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (username == '' || name == '' || email == '' || password == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {
            await axios.post(uAPIlocal + '/api/v1/master_users', formData, config)
                .then(response => {
                    // console.log(response)
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.getData();
                        this.tambahConc.current.close();
                        this.setState({
                            formTambah: {
                                ...this.state.formTambah,
                                field: {
                                    username: "",
                                    name: "",
                                    email: "",
                                    password: "",
                                    level: "",
                                    status_login: "",
                                    Company_ID: "",
                                    branch_code: "",
                                    ID_DOKTER: "",
                                },
                            },
                            chooseBranch: this.state.Branch[0],
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }

    async handleRemoveClick() {
        if (this.state.master_users.selection) {
            this.removeDialog.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async removedData() {
        await this.setState({
            loader: true
        })
        const id = this.state.master_users.selection.ID_KONSULTASI
        await axios.delete(uAPIlocal + `/api/v1/master_users/${id}`)
            .then(function (response) {
                // console.log(response)this.state.pasien.selection.id_regis
                return response.data;
            })
            .then(response => {
                // console.log(response)
                this.getData();
                this.removeDialog.current.close();
                this.setState({
                    loader: false,
                    master_users: {
                        ...this.state.master_users,
                        selection: null
                    },
                })




            })
            .catch(error => {
                console.log(error);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 500) {
                        this.setState({
                            loader: false,
                            errorMessage: error.response.data,
                        })
                        this.errorDialog.current.open();
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', error.message);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                }

            });
    }

    async handleEditClick() {
        if (this.state.master_users.selection) {
            console.log(this.state.master_users.selection)
            const username = `${this.state.master_users.selection.username}`;
            const name = `${this.state.master_users.selection.name}`;
            const email = `${this.state.master_users.selection.email}`;
            const password = `${this.state.master_users.selection.password}`;
            const level = `${this.state.master_users.selection.level}`;
            const status_login = `${this.state.master_users.selection.status_login}`;
            const Company_ID = `${this.state.master_users.selection.Company_ID}`;
            const branch_code = `${this.state.master_users.selection.branch_code}`;
            const ID_DOKTER = this.state.formEdit.field.ID_DOKTER;

            await this.setState({
                formEdit: {
                    ...this.state.formEdit,
                    field: {
                        username: username,
                        name: name,
                        email: email,
                        password: '',
                        level: level,
                        status_login: status_login,
                        Company_ID: Company_ID,
                        branch_code: branch_code,
                        ID_DOKTER: ID_DOKTER,
                    },
                },
            })

            this.editConc.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async handleChangeformEdit(name, value) {
        let field = Object.assign({}, this.state.formEdit.field);
        field[name] = value;
        await this.setState({
            formEdit: {
                ...this.state.formEdit,
                field: field
            }
        })
    }
    async handleSubmitformEdit() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const username = this.state.formEdit.field.username;
        const name = this.state.formEdit.field.name;
        const email = this.state.formEdit.field.email;
        const password = this.state.formEdit.field.password;
        const level = this.state.formEdit.field.level;
        const status_login = this.state.formEdit.field.status_login;
        const Company_ID = this.state.formEdit.field.Company_ID;
        const branch_code = this.state.formEdit.field.branch_code;
        const ID_DOKTER = this.state.formEdit.field.ID_DOKTER;


        formData.append('ID', this.state.master_users.selection.id);
        formData.append('username', username);
        formData.append('name', name);
        formData.append('email', email);

        if (this.state.formEdit.field.password == ''){
            formData.append('password', this.state.master_users.selection.password);
            formData.append('mode', 'normal');
        }else{
            formData.append('password', password);
            formData.append('mode', 'gantiPASS');
        }
       
        formData.append('level', this.state.selectedLevel[0].value);
        formData.append('status_login', this.state.selectedStatusLogin[0].value);
        formData.append('Company_ID', Company_ID);
        formData.append('branch_code', this.state.chooseBranch);
        formData.append('ID_DOKTER', this.state.chooseDokter);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (username == '' || name == '' ) {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {

            await axios.put(uAPIlocal + '/api/v1/master_users', formData, config)
                .then(response => {
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.setState({
                            master_users: {
                                ...this.state.master_users,
                                loading: true
                            }
                        })
                        this.getData();
                        this.editConc.current.close();
                        this.setState({
                            formEdit: {
                                ...this.state.formEdit,
                                field: {
                                    username: "",
                                    name: "",
                                    email: "",
                                    password: "",
                                    level: "",
                                    status_login: "",
                                    Company_ID: "",
                                    branch_code: "",
                                    ID_DOKTER: "",

                                },
                            },
                            chooseBranch: this.state.Branch[0],
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    }

    handleOnChangeLevel = (value, event) => {
        console.log(event);
        this.setState({selectedLevel: [{ value: event.value, label: event.label }] }, () => console.log(""))
        
    }

    handleOnChangeStatusLogin = (value, event) => {
        this.setState({selectedStatusLogin: [{ value: event.value, label: event.label }] }, () => console.log(""))
    }

    componentDidMount() {
        this.getData();
        this.getBranch();
        this.getDokter();
    }
    componentWillUnmount() {
        window.location.reload();
    }
    render() {



        return (

            <Row>


                <Dialog
                    title="Alert"
                    style={{ width: '300px', height: '84px' }}
                    modal
                    closed={true}
                    ref={this.errorDialog}
                >
                    <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>{this.state.errorMessage}</p>
                </Dialog>

                <Dialog title="Tambah Konsultasi"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.tambahConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formTambah}
                            style={{ maxWidth: 500, height: 600 }}
                            model={this.state.formTambah.field}
                            rules={this.state.formTambah.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeFormTambah}
                            virtualScroll
                        >
                            <FormField name="username" label="username">
                                <TextBox inputId="t1" name="username" value={this.state.formTambah.field.username} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="name" label="name">
                                <TextBox inputId="t2" name="name" value={this.state.formTambah.field.name} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="email" label="email">
                                <TextBox inputId="t3" name="email" value={this.state.formTambah.field.email} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="password" label="password">
                                <TextBox inputId="t4" name="password" value={this.state.formTambah.field.password} style={{ width: '100%' }}></TextBox>
                            </FormField>

                            <FormField name="1" label="LEVEL">
                                <Select
                                    value={this.state.selectedLevel}
                                    style={{ width: '100%' }}
                                    // onChange={handleChangeForLevel}
                                    onSelect={(value, event) => this.handleOnChangeLevel(value, event)}
                                    options={[
                                        { value: 1, label: "Administrasi" },
                                        { value: 4, label: "Analis / Perawat" },
                                        { value: 2, label: "Dokter" },
                                        { value: 3, label: "Super Admin" },
                                    ]}
                                />
                            </FormField>

                            <FormField name="status_login" label="STATUS LOGIN">
                                <Select
                                    // defaultValue={[{ value: 20, label: "20 Menit" }]}
                                    value={this.state.selectedStatusLogin}
                                    style={{ width: '100%' }}
                                    // onChange={handleChangeForStatus}
                                    onSelect={(value, event) => this.handleOnChangeStatusLogin(value, event)}
                                    options={[
                                        { value: "AKTIF", label: "AKTIF" },
                                        { value: "TIDAK AKTIF", label: "TIDAK AKTIF" },
                                    ]}
                                />
                            </FormField>

                            <FormField name="Company_ID" label="Company_ID">
                                <TextBox inputId="t6" name="Company_ID" value={this.state.formTambah.field.Company_ID} style={{ width: '100%' }}></TextBox>
                            </FormField>


                            <FormField name="branch_code" label="BRANCH">
                                <ComboBox onChange={this.changeSelectBranch}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Branch} value={this.state.chooseBranch} ></ComboBox>
                            </FormField>

                            <FormField name="ID_DOKTER" label="DOKTER">
                                <ComboBox onChange={this.changeSelectDokter}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Dokter} value={this.state.chooseDokter} ></ComboBox>
                            </FormField>


                            <FormField >
                                <LinkButton onClick={this.handleSubmitFormTambah} style={{ marginBottom: '20px' }}  >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>

                <Dialog title="Edit Konsultasi"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.editConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formEdit}
                            style={{ maxWidth: 500, height: 600 }}
                            model={this.state.formEdit.field}
                            rules={this.state.formEdit.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeformEdit}
                            virtualScroll
                        >
                              <FormField name="username" label="username">
                                <TextBox inputId="t1" name="username" value={this.state.formEdit.field.username} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="name" label="name">
                                <TextBox inputId="t2" name="name" value={this.state.formEdit.field.name} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="email" label="email">
                                <TextBox inputId="t3" name="email" value={this.state.formEdit.field.email} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            
                            <FormField name="password" label="password">
                                <TextBox inputId="t4" name="password" value="" style={{ width: '100%' }}></TextBox>
                            </FormField>

                            <FormField name="1" label="LEVEL">
                                <Select
                                    value={this.state.selectedLevel}
                                    style={{ width: '100%' }}
                                    // onChange={handleChangeForLevel}
                                    onSelect={(value, event) => this.handleOnChangeLevel(value, event)}
                                    options={[
                                        { value: 1, label: "Administrasi" },
                                        { value: 4, label: "Analis / Perawat" },
                                        { value: 2, label: "Dokter" },
                                        { value: 3, label: "Super Admin" },
                                    ]}
                                />
                            </FormField>

                            <FormField name="status_login" label="STATUS LOGIN">
                                <Select
                                    // defaultValue={[{ value: 20, label: "20 Menit" }]}
                                    value={this.state.selectedStatusLogin}
                                    style={{ width: '100%' }}
                                    // onChange={handleChangeForStatus}
                                    onSelect={(value, event) => this.handleOnChangeStatusLogin(value, event)}
                                    options={[
                                        { value: "AKTIF", label: "AKTIF" },
                                        { value: "TIDAK AKTIF", label: "TIDAK AKTIF" },
                                    ]}
                                />
                            </FormField>

                            <FormField name="Company_ID" label="Company_ID">
                                <TextBox inputId="t6" name="Company_ID" value={this.state.formEdit.field.Company_ID} style={{ width: '100%' }}></TextBox>
                            </FormField>


                            <FormField name="branch_code" label="BRANCH">
                                <ComboBox onChange={this.changeSelectBranch}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Branch} value={this.state.chooseBranch} ></ComboBox>
                            </FormField>

                            <FormField name="ID_DOKTER" label="DOKTER">
                                <ComboBox onChange={this.changeSelectDokter}
                                    style={{ width: '100%', height: '40px' }} data={this.state.Dokter} value={this.state.chooseDokter} ></ComboBox>
                            </FormField>


                            <FormField >
                                <LinkButton onClick={this.handleSubmitformEdit} style={{ marginBottom: '20px' }}  >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>
                <Dialog
                    title="Please Confirm"
                    style={{ width: '300px', height: '190px' }}
                    modal
                    closed={true}
                    ref={this.removeDialog}
                    footer={() => {
                        return (
                            this.state.loader ? (
                                <div className="text-center">
                                    <Loader type="TailSpin" color="#00BFFF" height={40} width={100} />
                                </div>
                            ) : (

                                <>
                                    <ButtonGroup style={{ width: '100%', height: '50px' }}>
                                        <LinkButton className="f-full mybtn" plain onClick={this.removedData}>Yakin</LinkButton>
                                        <LinkButton className="f-full mybtn" plain onClick={() => this.removeDialog.current.close()}>Cancel</LinkButton>
                                    </ButtonGroup>
                                </>
                            )
                        )
                    }}

                >
                    <>
                        <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>Apakah Anda Yakin ?</p>

                    </>
                </Dialog>


                <Col md="12" style={{ backgroundColor: "white", padding: "2px" }}>
                    <Panel
                        title="Master User"
                        collapsible
                    // bodyStyle={{ padding: 20 }}
                    // style={{ height: 500 }}
                    >
                        <Row style={{ padding: 0, marginBottom: 4, marginLeft: 2 }}>
                            <Col className="col-8">
                                <div style={{ marginTop: 10, marginLeft: 4 }}>
                                    <LinkButton
                                        iconCls="icon-add"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.addRow()}
                                        onClick={() => this.tambahConc.current.open()}
                                    >
                                        Tambah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-edit"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.editRow()}
                                        onClick={this.handleEditClick}
                                        disabled={this.state.master_users.selection ? false : true}
                                    >
                                        Ubah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-cancel"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.deleteRow()}
                                        onClick={this.handleRemoveClick}
                                        disabled={this.state.master_users.selection ? false : true}
                                    >
                                        Hapus
                                    </LinkButton>
                                </div>
                            </Col>
                        </Row>

                        <div id="DataGrid">
                            <DataGrid
                                {...this.state.master_users}
                                style={{ height: '70vh', }}
                                pagination
                                columnResizing
                                selectionMode="single"
                                onSelectionChange={this.selectionChange}
                                // onPageChange={this.pageChange}
                                filterable
                                virtualScroll
                                columnMoving
                            >
                                {/* <GridColumn
                                    field="rn"
                                    align="center"
                                    width="30px"
                                    cellCss="datagrid-td-rownumber"
                                    render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
                                    filterable={false}
                                /> */}
                                {/* <GridColumn
                                    field="ID_KONSULTASI"
                                    title="ID"
                                    align="center"
                                    width="40px"
                                ></GridColumn> */}
                                <GridColumn
                                    sortable
                                    field="name"
                                    title="NAMA"
                                    align="center"
                                    width="180px"
                                ></GridColumn>
                                <GridColumn
                                    field="username"
                                    title="USERNAME"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                                {/* <GridColumn
                                    field="email"
                                    title="EMAIL"
                                    align="center"
                                    width="100px"
                                ></GridColumn> */}
                                <GridColumn
                                    field="level"
                                    title="LEVEL"
                                    align="center"
                                    width="40px"
                                ></GridColumn>
                                 <GridColumn
                                    field="status_login"
                                    title="STATUS"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                                <GridColumn
                                    field="branch_name"
                                    title="CABANG"
                                    // hidden="true"
                                    align="center"
                                    width="100px"
                                ></GridColumn>
                                <GridColumn
                                    field="ID_DOKTER"
                                    title="ID DOKTER"
                                    // hidden="true"
                                    align="center"
                                    width="60px"
                                    render={({ row }) => {
                                        if (row.ID_DOKTER == 0){
                                            return <>{''}</>
                                        }else{
                                            return <>{row.ID_DOKTER}</>
                                        }
                                        
                                    }}
                                ></GridColumn>
                            </DataGrid>
                        </div>
                    </Panel>
                </Col>
            </Row>
        )
    }
}
export default MasterKonsultasi